import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DatashareService
 {

   
    unreadMsgCount: BehaviorSubject<number> = new BehaviorSubject(0);

    
    setMsgCount(data: number) {

        this.unreadMsgCount.next(data);
       
    }
    getMsgCount(): Observable<number> {
        return this.unreadMsgCount
    }
	
	
	

}